import React from 'react'
import styles from './hint-cell.styles'
import injectSheet from 'react-jss'
import Cell from '../cell/cell'
import classNames from 'classnames'

const HintCell = ({ classes, children, className }) => (
  <Cell className={classNames(classes.hintCell, className)}>
    <span className={classes.hint}>{children}</span>
  </Cell>
)

export default injectSheet(styles)(HintCell)
